export const CHANGE_FILTER = 'CHANGE_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';

export const STASH_PREVIOUS_FILTERS = 'STASH_PREVIOUS_FILTERS';
export const GET_PREVIOUS_FILTERS = 'GET_PREVIOUS_FILTERS';
export const SET_PREVIOUS_FILTERS = 'SET_PREVIOUS_FILTERS';

export const CLOSE_PREVIOUS_FILTERS = 'CLOSE_PREVIOUS_FILTERS';

export const FILTRATION_SUCCESS = 'FILTRATION_SUCCESS';

// MOBILE
export const SET_FILTERS = 'SET_FILTERS';
export const APPLY_FILTERS = 'APPLY_FILTERS';
export const CANCEL_FILTERS = 'CANCEL_FILTERS';
export const SAVE_FILTERS_FOR_CANCEL = 'SAVE_FILTERS_FOR_CANCEL';
